package org.dronda.app.web.client

import com.github.michaelbull.result.Err
import com.github.michaelbull.result.Ok
import com.github.michaelbull.result.Result
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.engine.js.Js
import io.ktor.client.plugins.contentnegotiation.ContentNegotiation
import io.ktor.client.plugins.defaultRequest
import io.ktor.client.plugins.logging.LogLevel
import io.ktor.client.plugins.logging.Logging
import io.ktor.client.request.accept
import io.ktor.client.request.forms.submitForm
import io.ktor.client.request.header
import io.ktor.client.request.post
import io.ktor.client.request.setBody
import io.ktor.http.ContentType
import io.ktor.http.HttpHeaders
import io.ktor.http.HttpStatusCode
import io.ktor.http.Parameters
import io.ktor.http.URLBuilder
import io.ktor.http.contentType
import io.ktor.http.path
import io.ktor.serialization.kotlinx.json.json
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.withContext
import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable
import kotlinx.serialization.json.Json
import org.dronda.app.web.service.AuthService
import org.dronda.application.config.BuildKonfig

class AuthClient() {
    private val client = HttpClient(Js) {
        install(ContentNegotiation) {
            json(Json { ignoreUnknownKeys = true })
        }
//        install(Logging) {
//            level = LogLevel.INFO
//        }

        defaultRequest {
            url(BuildKonfig.apiUrl)
        }
    }

    suspend fun refreshTokens(authToken: String, refreshToken: String): Result<AuthResponse, String> = withContext(Dispatchers.Main) {
        val response = client.post("/authentication/refresh") {
            contentType(ContentType.Application.Json)
            accept(ContentType.Application.Json)
            header(HttpHeaders.Authorization, "Bearer $authToken")

            setBody(RefreshRequest(
                refreshToken
            ))
        }

        if (response.status == HttpStatusCode.OK) {
            Ok(response.body())
        } else {
            Err("Refresh error")
        }
    }



    suspend fun exchangeAuthorizationCode(codeVerifier: String, authorizationCode: String): Result<AuthResponse, Unit> {
        val url = URLBuilder(BuildKonfig.apiUrl).apply {
            path("a", "token")
        }
        val response = client.submitForm(
            url.toString(),
            formParameters = Parameters.build {
                append("grant_type", "authorization_code")
                append("code", authorizationCode)
                append("client_id", BuildKonfig.clientId)
                append("redirect_uri", BuildKonfig.appUrl)
                append("code_verifier", codeVerifier)
            }
        )

        return if (response.status == HttpStatusCode.OK) {
            Ok(response.body())
        } else {
            Err(Unit)
        }
    }
}

@Serializable
data class AuthTokens(val accessToken: String, val refreshToken: String)

@Serializable
data class AuthResponse(
    val token: String,
    @SerialName("refresh_token")
    val refreshToken: String
)

@Serializable
private data class RefreshRequest(
    val refreshToken: String
)
